export default __webpack_public_path__ + "static/4-6ac1bc864237d89f6e255b5dd1583d97.jpeg";